<template>
  <div class="select-block" :class="{ select_style: selectStyle }">
    <el-select
      v-model="bindItem"
      v-loading="loading"
      :placeholder="placeholder"
      :value-key="bindKey"
      remote
      :clearable="clearable"
      :disabled="disabled"
      :filter-method="itemSearch"
      :loading="bindLoading"
      @change="handleChange"
      @clear="resetList"
      @focus="focusList"
      filterable
      :size="size"
    >
      <el-option
        class="select-item"
        v-for="item in itemList"
        :key="item[bindKey]"
        :label="bindProp!=''?item[bindProp][bindLabel]:item[bindLabel]"
        :value="item"
      >
        <div v-html="item.inner !== 'undefined'? item.inner : (bindProp!=''?item[bindProp][bindLabel]:item[bindLabel])"></div>
      </el-option>

      <div
        :class="['loadmores', isLoading == true ? 'loadmoresNO' : '']"
        @click="moreList"
      >
        {{ isLoading ? "没有更多了.." : "加载更多" }}
      </div>
    </el-select>
  </div>
</template>
<script>
import request from "@/router/axios";
export default {
  name: "CommonSelect",
  data() {
    return {
      loading: false,
      queryData: false,
      bindItem: {},
      searchName: "",
      itemList: [],
      isLoading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  props: {
    // 绑定option取的字段， 必传
    bindKey: {
      type: String,
      default: "id",
    },
    bindLabel: {
      type: String,
      default: "",
    },
    bindValue: {
      type: String,
      default: "",
    },
    // 数据地址, 必传
    dataUrl: {
      type: String,
      required: true,
    },
    // 绑定数据ID
    bindId: {
      type: String,
      default: "",
    },
    // 是否可用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 请求类型
    methods: {
      type: String,
      default: "post",
    },
    // 请求传参方式data/params
    dataMethod: {
      type: String,
      default: "data",
    },
    // 搜索关键词key
    searchKey: {
      type: String,
      default: "search",
    },
    // 默认传参
    initParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 样式
    selectStyle: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    // 搜索框额外显示的数据,比如  报价方案需要显示id
    innerKey: {
      type: String,
      default: "",
    },
    innerKeyName: {
      type: String,
      default: "",
    },
    bindProp: {
      type: String,
      default: ""
    },
    // 返回的数据名字
    listName: {
      type: String,
      default: "records",
    },
    // 提示
    placeholder: {
      type: String,
      default: "请选择",
    },
    // 是否显示清除按钮
    clearable: {
      type: Boolean,
      default: true,
    },
    // 是否为tableCustom 里面的下拉搜索
    isTableCustom: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    bindId: {
      handler(val) {
        let self = this;
        if (val) {
          let params = {};
          params[this.bindKey] = val;
          
          this.requestItemList(params).then((res) => {
            if (res.data.code == 200) {
              let resArray = [];
              if (Array.isArray(res.data.data)) {
                resArray = res.data.data;
              } else if (Array.isArray(res.data.data[this.listName])) {
                resArray = res.data.data[this.listName];
              }

              let filterArray = resArray.filter((item) => {
                return item[this.bindKey] == val;
              });
              if(filterArray.length > 0) {
                self.bindItem = filterArray[0]
              }else {
                // console.info(`Error: filterArray筛选错误--${filterArray}， bindId--${val}, resArray--${resArray}`)
              }
              self.itemList = resArray;
              self.isLoading = true;

              this.$emit("handleChange", self.bindItem);
              self.$forceUpdate();
            }
          });
        }else {
          if(this.isTableCustom){
            this.reset()
          }
         
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.itemSearch();
  },
  methods: {
    clearBindItem() {
      this.bindItem = {}
    },

    focusList() {
      this.itemList = [];
      this.page.currentPage = 1;
      if (this.searchName == "") {
        this.resetList();
      } else {
        this.queryList(this.searchName);
      }
    },
    reset() {
      this.bindItem = undefined;
      this.searchName = "";
    },
    resetList() {
      this.bindItem = undefined;
      this.searchName = "";
      this.$emit("handleChange", {});
      this.itemList = [];
      this.queryList();
    },
    // 获取流程详情
    requestItemList(data) {
      if (this.dataMethod == "data") {
        return request({
          url: `/api/${this.dataUrl}`,
          method: this.methods,
          data: data,
        });
      } else {
        return request({
          url: `/api/${this.dataUrl}`,
          method: this.methods,
          params: data,
        });
      }
    },

    // 更多
    moreList() {
      if (!this.isLoading) {
        this.page.currentPage++;
        this.queryList(this.searchName);
      }
    },

    itemSearch(query) {
      this.itemList = [];
      this.page.currentPage = 1;
      this.searchName = query;
      this.queryList(query);
    },

    /**
     * 查询列表
     * @param {*} query 搜索字段
     */
    async queryList(query) {
      if(this.queryData) {
        return false
      }
      let params = {
        firstNum: (this.page.currentPage - 1) * this.page.pageSize,
        num: this.page.pageSize,
        current: this.page.currentPage,
        size: this.page.pageSize,
        custType: 2,
        ...this.initParam,
      };
      params[this.searchKey] = query ? query : "";
      this.isLoading = false;
      this.loading = true
      this.queryData = true
      let res = await this.requestItemList(params);
      let resArray = [];
      if (res.data.code == 200) {
        if (Array.isArray(res.data.data)) {
          resArray = res.data.data.map((item) => {
            return {
              ...item,
              inner:
                (this.innerKey
                  ? this.innerKeyName +
                    item[this.innerKey] +
                    "&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp"
                  : "") + item[this.bindLabel],
            };
          });
        } else if (Array.isArray(res.data.data[this.listName])) {
          resArray = res.data.data[this.listName].map((item) => {
            return {
              ...item,
              inner:
                (this.innerKey
                  ? this.innerKeyName +
                    item[this.innerKey] +
                    "&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp"
                  : "") + item[this.bindLabel],
            };
          });
        } else {
          this.$message({
            type: "warning",
            message: "返回数据格式错误",
          });
          return false;
        }

        if (resArray.length < this.page.pageSize||res.data.data.size==-1) {
          this.isLoading = true;
        }
        if (resArray.length > 0) {
          // 合并this.itemList和res.data.data
          let itemList = this.itemList.concat(resArray);

          this.itemList = this.innerKey
            ? this.setHightLight(itemList, this.searchName)
            : itemList;
        } else {
          this.itemList = [];
        }
        this.queryData = false
        this.loading = false
      }
    },
    // 设置高亮
    setHightLight(arr, keyword) {
      if (arr && arr.length > 0 && keyword) {
        arr = arr.filter((item) => {
          let reg = new RegExp(keyword, "g");
          let replaceString = `<span class='high'>${keyword.trim()}</span>`;
          if (item.inner.match(reg)) {
            item.inner = item.inner.replace(reg, replaceString);
            return item;
          }
        });
        return arr;
      }

      // 空返回原数组
      if (!keyword) {
        return arr;
      }
    },
    handleChange(item) {
      if (item !== "") {
        this.$emit("handleChange", item);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-block {
  width: 100%;
  .select-item {
    padding: 0 20px !important;
  }
}
.loadmoresNO {
  font-weight: 400;
}
.loadmores {
  display: inline-block;
  text-align: center;
  line-height: 35px;
  font-size: 15px;
  color: #697289;
  padding: 0 20px;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
}
.select-item {
  padding: 0 20px !important;
}
/deep/.el-select-dropdown__item.selected {
  color: #606266;
}
/deep/.el-select-dropdown__item.hover {
  color: #409eff !important;
}
.select_style {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .high {
  color: red !important;
}
</style>